export default {
    name: 'Income & Expenses',
    headerRow: ['Income & Expenses', null, 'Total', 'PSF'],
    footerRow: {
        valueCells: [
            {
                editable: false,
                getComputedValue() {
                    return {displayValue: 'NET OPERATING INCOME'}
                }
            },
            {empty: true},
            {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const effectiveGrossIncome = tabs['marketing-tab'].tables['income-and-expenses'].rows['effective-gross-income'].valueCells[2].getComputedValue(tabs, 'effective-gross-income', precomputedValues).internalValue;
                    const totalExpenses = tabs['marketing-tab'].tables['income-and-expenses'].rows['total-expenses'].valueCells[2].getComputedValue(tabs, 'total-expenses', precomputedValues).internalValue;
                    const value = effectiveGrossIncome + (-totalExpenses);
                    const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                    return {internalValue: value, displayValue: displayValue}
                }
            },
            {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const value = parseFloat(precomputedValues.netOperatingIncome / precomputedValues.totalSpace);
                    const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                    return {internalValue: value, displayValue: displayValue}
                }
            },
        ]
    },
    rows: {
        'base-rent-occupied-space': {
            valueCells: [
                {
                    editable: false,
                    hasExpandButton: true,
                    getComputedValue() {
                        return {displayValue: 'Base Rent - Occupied Space'}
                    }
                },
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[1].getComputedValue(tabs, precomputedValues).internalValue);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2})}%`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // Total
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
        'base-rent-lease-up-space': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Base Rent - Lease Up Space'}
                    }
                },
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[1].getComputedValue(tabs, precomputedValues).internalValue);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2})}%`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
        'base-rent-additional-price': {
            valueCells: [
                {
                    editable: false,
                    hidden: true,
                    getComputedValue(tabs) {
                        const displayValue = tabs['pricing-tab'].tables['base-rent'].rows['additional-price'].valueCells[0].value || '';
                        return {displayValue: `Base Rent - ${displayValue}`};
                    }
                },
                {
                    empty: true,
                    hidden: true
                },
                {
                    editable: false,
                    hidden: true,
                    getComputedValue(tabs) {
                        const value = Math.round(tabs['pricing-tab'].tables['base-rent'].rows['additional-price'].valueCells[2].value);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
                { // PSF
                    editable: false,
                    hidden: true,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
            ]
        },
        'gross-potential-rent': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'GROSS POTENTIAL RENT'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const occupiedTotal = tabs['marketing-tab'].tables['income-and-expenses'].rows['base-rent-occupied-space'].valueCells[2].getComputedValue(tabs, 'base-rent-occupied-space', precomputedValues).internalValue;
                        const leaseUpTotal = tabs['marketing-tab'].tables['income-and-expenses'].rows['base-rent-lease-up-space'].valueCells[2].getComputedValue(tabs, 'base-rent-lease-up-space', precomputedValues).internalValue;
                        const additionalPrice = parseInt(tabs['pricing-tab'].tables['base-rent'].rows['additional-price'].valueCells[2].value) || 0;
                        const value = occupiedTotal + leaseUpTotal + additionalPrice;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const occupiedPsf = tabs['marketing-tab'].tables['income-and-expenses'].rows['base-rent-occupied-space'].valueCells[3].getComputedValue(tabs, 'base-rent-occupied-space', precomputedValues).internalValue;
                        const leaseUpPsf = tabs['marketing-tab'].tables['income-and-expenses'].rows['base-rent-lease-up-space'].valueCells[3].getComputedValue(tabs, 'base-rent-lease-up-space', precomputedValues).internalValue;
                        const value = occupiedPsf + leaseUpPsf;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
        'exp-reimb': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Exp. Reimb.'}
                    }
                },
                {empty: true},
                {empty: true},
                {empty: true},

            ]
        },
        'real-estate-taxes': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Real Estate Taxes'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['pricing-tab'].tables['exp-reimb'].rows['real-estate-taxes'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
        'insurance': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Insurance'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['pricing-tab'].tables['exp-reimb'].rows['insurance'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
        'cam': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'CAM'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['pricing-tab'].tables['exp-reimb'].rows['cam'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
        'mgmt-fee': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Management Fee'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['pricing-tab'].tables['exp-reimb'].rows['mgmt-fee'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
        'total-exp-reimb': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Total Exp. Reimb.'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['pricing-tab'].tables['exp-reimb'].footerRow.valueCells[2].getComputedValue(tabs, precomputedValues).internalValue);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
        'gross-potential-income': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'GROSS POTENTIAL INCOME'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const grossPotentialRent = tabs['marketing-tab'].tables['income-and-expenses'].rows['gross-potential-rent'].valueCells[2].getComputedValue(tabs, 'gross-potential-rent', precomputedValues).internalValue;
                        const totalExpReimb = tabs['marketing-tab'].tables['income-and-expenses'].rows['total-exp-reimb'].valueCells[2].getComputedValue(tabs, 'total-exp-reimb', precomputedValues).internalValue;
                        const value = grossPotentialRent + totalExpReimb;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
        'vacancy-factor': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Vacancy Factor'}
                    }
                },
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = parseFloat(tabs['pricing-tab'].tables['total-gross-revenue'].rows['vacancy-factor'].valueCells[1].value);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2})}%`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = parseFloat(tabs['pricing-tab'].tables['total-gross-revenue'].rows['vacancy-factor'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue);
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString(undefined, {maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {maximumFractionDigits: 2})})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
            ]
        },
        'effective-gross-income': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'EFFECTIVE GROSS INCOME'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const grossPotentialIncome = tabs['marketing-tab'].tables['income-and-expenses'].rows['gross-potential-income'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const vacancy = tabs['marketing-tab'].tables['income-and-expenses'].rows['vacancy-factor'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const value = grossPotentialIncome + vacancy;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
            ]
        },
        'expenses': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Expenses'}
                    }
                },
                {empty: true},
                {empty: true},
                {empty: true},
            ]
        },
        'expenses-real-estate-taxes': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Real Estate Taxes'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs['pricing-tab'].tables['expenses'].rows['real-estate-taxes'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
            ]
        },
        'expenses-insurance': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Insurance'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs['pricing-tab'].tables['expenses'].rows['insurance'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
            ]
        },
        'expenses-cam': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'CAM'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs['pricing-tab'].tables['expenses'].rows['cam'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
            ]
        },
        'expenses-mgmt-fee': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Mgmt. Fee'}
                    }
                },
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = parseFloat(tabs['pricing-tab'].tables['expenses'].rows['mgmt-fee'].valueCells[1].value);
                        const displayValue = !value || isNaN(value) ? '-' : `${value.toLocaleString()}%`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs['pricing-tab'].tables['expenses'].rows['mgmt-fee'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
            ]
        },
        'non-reimbursable-expenses': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Non-Reimbursable Expenses'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs['pricing-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
            ]
        },
        'total-expenses': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'TOTAL EXPENSES'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const realEstateTaxes = Math.abs(tabs['marketing-tab'].tables['income-and-expenses'].rows['expenses-real-estate-taxes'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                        const insurance = Math.abs(tabs['marketing-tab'].tables['income-and-expenses'].rows['expenses-insurance'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                        const cam = Math.abs(tabs['marketing-tab'].tables['income-and-expenses'].rows['expenses-cam'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                        const mgmtFee = Math.abs(tabs['marketing-tab'].tables['income-and-expenses'].rows['expenses-mgmt-fee'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                        const nonReimbursableExpenses = Math.abs(tabs['marketing-tab'].tables['income-and-expenses'].rows['non-reimbursable-expenses'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                        const value = realEstateTaxes + insurance + cam + mgmtFee + nonReimbursableExpenses;
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString(undefined, {maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {maximumFractionDigits: 2})})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['income-and-expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat(total / totalSpace);
                        const displayValue = !value || isNaN(value) ? '-' :  value < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
            ]
        },
        'empty-row': {
            valueCells: [{empty: true},{empty: true},{empty: true},{empty: true},]
        }
    },
};